import useModalStore from '@/stores/useModalStore'
import { TFunction } from 'i18next'
import PlaceholderHelpText from './PlaceholderHelpText'

const froalaCustomSetup = (
  FroalaEditor: any,
  {
    t,
    placeholders,
  }: {
    t: TFunction
    placeholders: any
  },
) => {
  if (!FroalaEditor) {
    return
  }

  FroalaEditor.DefineIcon('placeholderInfo', { NAME: 'info', SVG_KEY: 'help' })

  FroalaEditor.RegisterCommand('placeholderInfo', {
    title: t('About placeholders'),
    focus: false,
    undo: false,
    refreshAfterCallback: false,
    callback: function () {
      useModalStore.getState().openModal({
        body: <PlaceholderHelpText />,
        isPage: false,
        size: 'large',
        form: false,
        closeConfirm: false,
        closeOnDimmerClick: true,
        header: t('About placeholders'),
        saveButtonText: '',
      })
    },
  })

  FroalaEditor.DefineIconTemplate(
    'placeholder',
    '<i aria-hidden="true" class="icon-placeholder02 icon"></i>',
  )

  FroalaEditor.DefineIcon('placeholderDropdown', {
    NAME: 'placeholder',
    template: 'placeholder',
  })

  FroalaEditor.RegisterCommand('placeholderDropdown', {
    title: t('Insert placeholder'),
    type: 'dropdown',
    focus: false,
    undo: true,
    refreshAfterCallback: true,
    options: placeholders,
    callback: function (cmd: any, val: string) {
      this.html.insert(`{{${val}}}`)
    },
  })

  FroalaEditor.DefineIconTemplate(
    'insertConditionalPlaceholder',
    '<i aria-hidden="true" class="icon-placeholder01 icon" style="color: green;"></i>',
  )

  FroalaEditor.DefineIcon('insertConditionalPlaceholder', {
    NAME: 'insertConditionalPlaceholder',
    template: 'insertConditionalPlaceholder',
  })

  FroalaEditor.RegisterCommand('insertConditionalPlaceholder', {
    title: t('Insert conditional placeholder'),
    focus: true,
    undo: true,
    refreshAfterCallback: true,
    callback: function () {
      const conditionalName = prompt(
        t('Type in a name for the conditional placeholder'),
      )

      if (!conditionalName) {
        return
      }

      this.html.insert(
        `{{#${conditionalName}}}${this.selection.text()}{{/${conditionalName}}}`,
      )
    },
  })

  FroalaEditor.DefineIconTemplate(
    'insertInvertedConditionalPlaceholder',
    '<i aria-hidden="true" class="icon-placeholder01 icon" style="color: red;"></i>',
  )

  FroalaEditor.DefineIcon('insertInvertedConditionalPlaceholder', {
    NAME: 'insertInvertedConditionalPlaceholder',
    template: 'insertInvertedConditionalPlaceholder',
  })

  FroalaEditor.RegisterCommand('insertInvertedConditionalPlaceholder', {
    title: t('Insert inverted conditional placeholder'),
    focus: true,
    undo: true,
    refreshAfterCallback: true,
    callback: function () {
      const conditionalName = prompt(
        t('Type in a name for the conditional placeholder'),
      )

      if (!conditionalName) {
        return
      }

      this.html.insert(
        `{{^${conditionalName}}}${this.selection.text()}{{/${conditionalName}}}`,
      )
    },
  })
}

export default froalaCustomSetup
